import React, { JSX, useContext } from "react";
import LoadingSpinner from "@app/shared/LoadingSpinner";
import { BenchmarkingFiltersContext } from "@app/overviews/network-benchmarking-dashboard/filters/BenchmarkingFiltersContext";
import { CompetitiveInsightsMap } from "@app/overviews/network-benchmarking-dashboard/filters/CompetitiveInsightsMap";
import { CompetitiveInsightsViewTypeEnum } from "@app/overviews/network-benchmarking-dashboard/filters/shared";
import { MedicaidFiltersContext } from "@app/overviews/network-benchmarking-dashboard/medicaid/filters/MedicaidFiltersContext";
import MedicaidNetworkFilters from "@app/overviews/network-benchmarking-dashboard/medicaid/filters/MedicaidNetworkFilters";
import MedicaidPrimaryFilters from "@app/overviews/network-benchmarking-dashboard/medicaid/filters/MedicaidPrimaryFilters";

interface MedicaidFiltersProps {
  selectedView: CompetitiveInsightsViewTypeEnum;
}

const MedicaidFilters = (props: MedicaidFiltersProps): JSX.Element => {
  const benchmarkingFiltersContext = useContext(BenchmarkingFiltersContext);
  const medicaidFiltersContext = useContext(MedicaidFiltersContext);

  return (
    <React.Fragment>
      {!benchmarkingFiltersContext.displayedPrimaryFilters && (
        <div className="row">
          <div className="col-12">
            <label className="copy-text-default mb-3">
              Please begin by selecting and applying your filters to view available networks for comparison.
            </label>
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-12">
          <div>
            <div>
              <MedicaidPrimaryFilters />

              {(!medicaidFiltersContext.primaryFiltersLoading && !!benchmarkingFiltersContext.states?.length) ? (
                props.selectedView === CompetitiveInsightsViewTypeEnum.MapView ? (
                  <CompetitiveInsightsMap
                    networkFiltersLoading={medicaidFiltersContext.networkFiltersLoading}
                    parentOrganizations={medicaidFiltersContext.parentOrganizations}
                    selectedNetworkCount={benchmarkingFiltersContext.selectedNetworks?.length}
                    showNetworks={!!benchmarkingFiltersContext.displayedPrimaryFilters}
                  />
                ) : (
                  !!benchmarkingFiltersContext.displayedPrimaryFilters && (
                    <MedicaidNetworkFilters />
                  )
                )
              ) : (
                <div className="text-center">
                  <LoadingSpinner />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default MedicaidFilters;